// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"6c60413d","453":"1225fc27","667":"fe3b2423","977":"cd767475"}[chunkId] + ".chunk.js";
};